function menuMobile( device_data ) {

  if (device_data.isDesktop) return
  
  const btn_togg = document.querySelectorAll('.togg');
  const toggler = document.querySelector('body.toggler');
  const submenus = document.querySelectorAll('.has-submenu');

  function menuToggler() {
    if (!toggler) return;
    toggler.classList.toggle('menu-in');
  }

  btn_togg.forEach(btn => {
    btn.addEventListener('click', menuToggler);
  });

  // Accordion functionality for mobile submenus
  const submenuTriggers = document.querySelectorAll('.submenu-trigger');
  
  submenuTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      
      const parent = trigger.closest('.has-submenu');
      if (!parent) return;
      
      // Close all other submenus
      submenus.forEach(item => {
        if (item !== parent) {
          item.classList.remove('active');
        }
      });
      
      // Toggle current submenu
      parent.classList.toggle('active');
    });
  });

}

export default menuMobile